import {
  pluralizeParticipants,
  pluralizePeople,
  pluralizeWithdrawals,
} from '@/features/dashboard/bookingChanges/utils/plurals.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';
import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import { StatusTone } from '@/components/ui/statusTone.ts';
import { formatSignedMoneyList } from '@/features/dashboard/bookingChanges/utils/formatters.ts';
import { pluralizeItems } from '@/features/dashboard/bookingChanges/utils/plurals.ts';

/** Ton statusu rezerwacji — ten sam zestaw, co karta stanu rezerwacji. */
export const bookingStatusTone: Record<BookingStatus, StatusTone> = {
  [BookingStatus.ACTIVE]: 'success',
  [BookingStatus.CANCELLED]: 'error',
};

/** Zakres szkicu w belce nagłówka — w edycji liczy się sama liczba pozycji. */
export const draftScopeLabel = (
  draft: ChangeDraftVm,
  isEditing: boolean,
): string =>
  isEditing
    ? `${pluralizeItems(draft.itemCount)} w rezerwacji`
    : `${pluralizeItems(draft.itemCount)}, wpływ ${formatSignedMoneyList(draft.totalDelta)}`;

/**
 * „2 uczestników”, a przy rezygnacjach „2 uczestników · 1 rezygnacja”.
 *
 * Liczba jadących to liczba tych, którzy zostali: uczestnik po rezygnacji
 * zostaje w rezerwacji, ale wliczanie go do „2 uczestników” mówiłoby
 * operatorowi, że jadą dwie osoby.
 */
export const participantCountLabel = (
  participants: ReadonlyArray<{ withdrawn?: boolean }>,
): string => {
  const withdrawn = participants.filter((tile) => tile.withdrawn).length;
  const active = pluralizeParticipants(participants.length - withdrawn);

  return withdrawn > 0
    ? `${active} · ${pluralizeWithdrawals(withdrawn)}`
    : active;
};

/** „3 osoby”, a przy rezygnacjach „2 osoby · 1 rezygnacja” — ta sama zasada co `participantCountLabel`. */
export const peopleCountLabel = (
  people: ReadonlyArray<{ withdrawn?: boolean }>,
): string => {
  const withdrawn = people.filter((entry) => entry.withdrawn).length;
  const active = pluralizePeople(people.length - withdrawn);

  return withdrawn > 0
    ? `${active} · ${pluralizeWithdrawals(withdrawn)}`
    : active;
};
